import { createReducer } from '@reduxjs/toolkit'
import { BusinessType } from 'interfaces/api/templates.interfaces'
import { ValidationErrorsApi } from 'packages/api'
import { createBuilder } from 'packages/redux-toolkit'

import {
  createBusinessType,
  getAllBusinessTypes,
  getBusinessType,
  setBusinessTypeValidationErrors,
  setSingleBusinessType,
  updateBusinessType,
} from './actions'

interface BusinessTypesState {
  list: {
    loading: boolean
    items: BusinessType[]
    count: number
  }
  single: {
    loading: boolean
    item: BusinessType | null
  }
  validation: ValidationErrorsApi | null
}

const initialState: BusinessTypesState = {
  list: {
    loading: false,
    items: [],
    count: 0,
  },
  single: {
    loading: false,
    item: null,
  },
  validation: null,
}

export const businessTypesReducer = createReducer(initialState, (builder) => {
  createBuilder(builder)
    .addCase(getAllBusinessTypes.pending, (state) => {
      state.list.loading = true
    })
    .addCase(getAllBusinessTypes.rejected, (state) => {
      state.list.loading = false
    })
    .addCase(getAllBusinessTypes.fulfilled, (state, { payload }) => {
      state.list.loading = false
      state.list.items = payload.results
      state.list.count = payload.count
    })

    .addCase(getBusinessType.pending, (state) => {
      state.single.loading = true
    })
    .addCase(getBusinessType.rejected, (state) => {
      state.single.loading = false
      state.single.item = null
    })
    .addCase([getBusinessType.fulfilled, setSingleBusinessType], (state, { payload }) => {
      state.single.loading = false
      state.single.item = payload
    })

    .addCase(setBusinessTypeValidationErrors, (state, { payload }) => {
      state.validation = payload
    })

    .addCase([createBusinessType.pending, updateBusinessType.pending], (state) => {
      state.single.loading = true
    })
    .addCase([createBusinessType.rejected, updateBusinessType.rejected], (state) => {
      state.single.loading = false
    })
    .addCase([createBusinessType.fulfilled, updateBusinessType.fulfilled], (state) => {
      state.single.loading = false
    })
})
